import { Component, OnInit } from '@angular/core';
import { NgxPermissionsService } from "ngx-permissions"
import { UserProfileService } from '../_services/user-profile.service'
import { UserProfile } from '../_models/user-profile';
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'app-control-panel',
  templateUrl: './control-panel.component.html'
})
export class ControlPanelComponent implements OnInit {
  public up: UserProfile;
  constructor(
    private ups: UserProfileService,
    private permissionService: NgxPermissionsService,
    private titleService: Title
  ) {
    ups.userProfile$.subscribe(result => {
      this.up = result;
    })
  }

  ngOnInit(): void {
    this.permissionService.loadPermissions(this.up.permissions);
    this.titleService.setTitle('Control Panel - Productioneer Portal');
  }

}
